export default __webpack_public_path__ + "static/media/pos-pro-2.eee015e9.jpg";